<!-- TEXTBOX -->
@if (entry.base?.display) {
  <form
    [connect]="'payloadStates.' + entry?.formControlAttributes?.connectPath"
    class="question-class"
    [formGroup]="form"
    >
    <mat-label>{{entry?.formControlAttributes?.label}}@if (valueRequired) {
      <span
      [ngStyle]="{'color': (formControls[entry?.formControlAttributes?.formControlName].errors) ? '#a71919' : '#084266'}"> *</span>
    }</mat-label>
    @if (entry?.base?.tooltip && entry?.base?.display) {
      <div class="premium-tooltip" matTooltip="{{entry?.base?.tooltip}}">
        <span class="material-symbols-outlined">info</span>
      </div>
    }
    @if (entry?.custom?.subLabel) {
      <div [innerHTML]="entry?.custom?.subLabel"></div>
    }
    <mat-radio-group
      [formControlName]="entry?.formControlAttributes?.formControlName"
      [attr.aria-label]="entry?.radioGroupAttributes?.label"
      [ngClass]="{'change-direction' : entry?.custom?.order === 'column' ? true:false}"
      >
      @for (buttonConfig of entry?.radioGroupAttributes?.optionAttributes; track buttonConfig; let j = $index) {
        <mat-radio-button [value]="buttonConfig.value">
          {{buttonConfig.label}}
          <!-- Form Entries Loop -->
          @for (entry of buttonConfig?.custom?.entries; track entry; let i = $index) {
            <div class="form-row"
              [ngClass]="{ 'hide-entry': entry.base?.foreverHidden }">
              <ptl-entry-as-json [entryConfig]="entry" [form]="radioFormGroups[j]" [currentPage]="currentPage" [formConfig]="formConfig">
              </ptl-entry-as-json>
            </div>
          }
        </mat-radio-button>
      }
    </mat-radio-group>
    @if (formControls[entry?.formControlAttributes?.formControlName]?.errors?.required) {
      <mat-error>Required</mat-error>
    }
  </form>
}
